/**
 * 计数展示格式化(TAPD 1006913)
 *
 * 落地页只用它格式化只读点赞数。口径必须与 App 侧
 * `needleApp/needle2020/src/base/utils/formatCount.js` 一致 —— 同一条视频在两个端
 * 显示两个数(App「1.2w」/ 落地页「12345」)看着就像 bug,而 13px 数字塞进 44px 宽的
 * 右侧栏还会挤出去。
 *
 * 两仓不共享代码,所以这里是复制的一份;改口径记得两边一起改。规则:
 *   1000~9999 → 1.2k、10000~99999 → 1.2w、≥100000 → 12w,整数省掉 .0。
 *
 * 取一位小数**向下截断**不四舍五入(与 App 侧同):9999 → 9.9k 而不是 10k
 * (那正好等于下一档的 1w,数字变大了看着反而变小)。
 * ⚠️ 不能写成 Math.floor(n / unit * 10) / 10:29000/10000*10 在 IEEE754 下是
 * 28.999999999999996,floor 完会变成 2.8w。所以先除到"十分之一档"再取整。
 */
const trimZero = text => text.replace(/\.0/g, '')

const truncTenths = (number, unit) => Math.floor(number / (unit / 10)) / 10

export const formatCount = count => {
  const number = Number(count)
  if (!isFinite(number) || number <= 0) return 0
  if (number >= 100000) return `${Math.floor(number / 10000)}w`
  if (number >= 10000) return `${trimZero(truncTenths(number, 10000).toFixed(1))}w`
  if (number >= 1000) return `${trimZero(truncTenths(number, 1000).toFixed(1))}k`
  return number
}

export default formatCount



// WEBPACK FOOTER //
// ./src/modules/videoShare/formatCount.js